import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/core';
import { OAUTH_POST_MESSAGE_NAME } from 'account-hybrid/common/constants/oauth-post-message-name.const';

@Component({
    selector: 'ft-oauth-result-view',
    templateUrl: './oauth-result-view.component.html',
    styleUrls: ['./oauth-result-view.component.scss'],
    standalone: false
})
export class OauthResultViewComponent implements OnInit {
    constructor(private transition: Transition) {
    }

    ngOnInit() {
        if (window.opener) {
            const params = this.transition.params();
            window.opener.postMessage({
                type: OAUTH_POST_MESSAGE_NAME,
                payload: {
                    batch: params?.batch,
                    result: JSON.parse(params?.result),
                    companyUuid: params?.companyUuid,
                    propertyUuid: params?.propertyUuid,
                    error: params?.error,
                    errorMessage: params?.errorMessage
                }
            }, window.location.origin);
            window.close();
        } else {
            document.body.innerText = 'Failed to post auth result.';
        }
    }
}
